<template>
  <div id="mockExam">
    <mock-header :title="courseName"/>
    <div class="main container">
      <el-row :gutter="24" style="width:100%;height:100%;" v-if="isRender">
        <el-col :span="5" style="min-height: 100%" class="sidebar">
          <div class="switch">
            <el-select placeholder="切换课程" v-model="siteCourseID" @change="toggleCourse()">
              <el-option v-for="(item,idx) in courseList" :key="idx" :label="item.siteCourseName"
                         :value="item.siteCourseID"/>
            </el-select>
          </div>
          <div class="lnavtit">系统管理目录</div>
          <div class="navcon">
            <ul>
              <li v-for="(item,idx) in menuList" :key="idx" @click="toMenuFn(item.menuID)">
                <span v-text="item.menuName" :class="{active:idx===currentIndex}"/>
              </li>
            </ul>
          </div>
          <common-tips/>
        </el-col>
        <el-col :span="19" style="min-height: 100%;overflow:hidden">
          <router-view :pre-exam-url="preExamURL" :faqs="faqs" :blessings="blessings" :showStatus.sync="showStatus"/>
        </el-col>
      </el-row>
    </div>
    <common-footer/>
  </div>
</template>
<script>
  import { MockHeader, CommonFooter, CommonTips } from "@components/common"
  import { parseNumber, LoadingOptions, setPageTitle, getCookie,setCookie } from "@/utils"
  import { getMoniExamTheme } from '@api'

  export default {
    name: "mockExam",
    components: {
      MockHeader,
      CommonFooter,
      CommonTips
    },
    watch: {
      $route(to) {
        this.getCurrentIndex(to.name)
      }
    },
    computed: {
      isRender() {
        return Object.keys(this.menuList).length > 0
      }
    },
    data() {
      return {
        //Query参数
        courseID: "",
        siteCourseID: "",
        majorID: "",
        flag: "",
        //列表
        courseList: [],
        menuList: [],
        //其他变量
        courseName: "",
        loadingInstance: null,
        currentIndex: 0,
        preExamURL: "",
        faqs: [],
        blessings: {},
        showStatus: true
      }
    },
    async mounted() {
      this.initData()
      await this.getCourseInfo()
      await this.getExamThemeList()
      this.getCurrentIndex(this.$route.name)
    },
    methods: {
      initData() {
        const { majorID } = this.$categoryInfo
        const { flag } = this.$route.params
        const { siteCourseID, courseID } = this.$route.query
        this.flag = flag === 'paidExam' ? '' : flag
        this.majorID = majorID
        this.courseID = parseNumber(courseID)
        this.siteCourseID = parseNumber(siteCourseID)
        this.loadingInstance = this.$loading(LoadingOptions)
      },
      async getCourseInfo() {
        let params = {
          flag: this.flag,
          majorID: this.majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch("getCurrentSiteInfo", params).then(res => {
          const { allSiteList, currentCourse } = res
          this.courseList = allSiteList
          const { siteCourseName } = currentCourse
          document.title = setPageTitle(siteCourseName)
          this.courseName = siteCourseName
          setCookie('courseName',this.courseName)
        }).catch(err => {
          this.$message.error(err.msg)
        })
      },
      async getExamThemeList() {
        const sid = getCookie('sid') || ''
        let params = {
          siteCourseID: this.siteCourseID,
          courseID: this.courseID,
          flag: this.flag
        }
        await getMoniExamTheme(params, sid).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })

          const { menu, module } = res
          if (!menu.length) {
            this.$message.error('学员您好，很抱歉本门课程您没有开通。如有疑问请联系客服！')
            return
          }

          this.menuList = menu
          const { blessings, faqs, preExam } = module
          this.preExamURL = preExam.url
          this.faqs = faqs
          this.blessings = blessings
        }).catch(err => {
          this.$message.error(err.msg)
        })
      },
      getCurrentIndex(name) {
        this.menuList.find((item, idx) => {
          if (item.menuID === name) {
            this.currentIndex = idx
            return true
          } else {
            return false
          }
        })
      },
      toggleCourse() {
        this.courseList.forEach(item => {
          if (item.siteCourseID === this.siteCourseID) {
            this.siteCourseID = item.siteCourseID
            this.courseID = item.courseID
            document.title = setPageTitle(item.siteCourseName)
            this.courseName = item.siteCourseName
            const { flag } = this.$route.params
            this.$router.push({
              path: `/${ flag }/mockExam`,
              query: {
                siteCourseID: item.siteCourseID,
                courseID: item.courseID
              }
            })
            this.getCourseInfo()
            this.getExamThemeList()
          }
        })
      },
      toMenuFn(menuID) {
        this.showStatus = true
        if (menuID === 'collectRecord') {
          let url = `//member.jianshe99.com/qzs/apiindex.html#/questionBank/SimMyCollection?courseID=${ this.courseID }&siteCourseID=${ this.siteCourseID }`
          window.open(url, '_blank')
        } else {
          const { flag } = this.$route.params
          let queryParams = {
            siteCourseID: this.siteCourseID,
            courseID: this.courseID
          }
          if(menuID === 'examChapter'){
            queryParams.time = (new Date).getTime()
          }
          this.$router.push({
            path: `/${ flag }/mockExam/${ menuID }`,
            query: queryParams
          })
        }
      }
    }
  }
</script>
